module.exports = __webpack_public_path__ + "img/lerato.a81136ea.jpg";